export * from './transactionLogs.service';
import { TransactionLogsService } from './transactionLogs.service';
export * from './uSSDTransactionLog.service';
import { USSDTransactionLogService } from './uSSDTransactionLog.service';
export const APIS = [TransactionLogsService, USSDTransactionLogService];
